module.exports = __webpack_public_path__ + "img/logoUnderline.dee940e4.png";